import React, { useEffect, useState } from 'react';
import './App.css';
// import axios from 'axios';

import AppRoutes from './AppRoutes';
// import EditIcon from '@mui/icons-material/Edit';
// import DeleteIcon from '@mui/icons-material/Delete';
// import SaveIcon from '@mui/icons-material/Save';
// import Brightness4Icon from '@mui/icons-material/Brightness4';
// import Brightness7Icon from '@mui/icons-material/Brightness7';

const App: React.FC = () => {
  // Determine initial dark mode setting based on system preference
  // const prefersDarkMode = window.matchMedia('(prefers-color-scheme: dark)').matches;
  // const [darkMode, setDarkMode] = useState(prefersDarkMode);

  // const [todoItems, setTodoItems] = useState<TodoItem[]>([]);
  // const [newTodo, setNewTodo] = useState<string>('');
  // const [editingTodoId, setEditingTodoId] = useState<number | null>(null);
  // const [editingTodoText, setEditingTodoText] = useState<string>('');
  // const [error, setError] = useState<string | null>(null);
  // const currentYear = new Date().getFullYear();

  // Set from Dockerfile. Static react needs to be rebuilt to change this value
  // This should be the only environment variable for the frontend. Dynamic environment variables should be handled by the API/backend
  // const API_BASE_URL = process.env.REACT_APP_API_URL;


  // return (
  //   <>
  //   <h1>Hello Compayr</h1>
  //   </>
  // );
   return <AppRoutes />;
};

export default App;